import { Component, inject } from "@angular/core";
import { TilbakeLink } from "../../components/tilbake-link/tilbake-link";
import { OppsummeringApiService } from "../../services/oppsummering/oppsummering-api-service";
import { ActivatedRoute } from "@angular/router";
import { LastNedPdfCard } from "./components/last-ned-pdf-card/last-ned-pdf-card";

@Component({
  selector: "bko-tiltak-pdf",
  imports: [TilbakeLink, LastNedPdfCard],
  templateUrl: "./del-boligkompass.html",
  styleUrl: "./del-boligkompass.scss",
})
export class DelBoligkompass {
  private oppsummeringApiService = inject(OppsummeringApiService);
  private route = inject(ActivatedRoute);

  lastNedPdf(): void {
    const id = this.route.snapshot.paramMap.get("id");
    if (!id) {
      console.log(history.state);

      return;
    }
    this.oppsummeringApiService.getPdf(id).subscribe(pdf => {
      const url = window.URL.createObjectURL(pdf);
      const a = document.createElement("a");
      a.href = url;
      a.download = "boligkompasset-resultat.pdf";
      a.click();

      window.URL.revokeObjectURL(url);
    });
  }
}
